import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './MasterSlavePanel.module.less';

export default function MasterPanel({className, style, children}) {
    return (
        <div className={classNames(styles.masterContainer, className)} style={style}>
            {children}
        </div>
    );
}

MasterPanel.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.node,
};
